import React, { useState, useEffect, useRef } from "react";
import "./AnnualdayImageSlider.css";

const AnnualDayImageSwapper = () => {
  const [images, setImages] = useState([]);
  const [offset, setOffset] = useState(0);
  const containerRef = useRef(null);

  const visibleCount = 5;

  // ✅ Fetch images from backend
  useEffect(() => {
    fetch("https://kkblossomschool.org/KKBlossomsWebsite/api.php?action=getCelebrations")
      .then((res) => res.json())
     .then((data) => {
  console.log("Celebrations Data:", data);

  const formattedImages = data.map(
    (item) => `https://kkblossomschool.org/KKBlossomsWebsite/uploads/AnnualDayImg/${item.image}`
  );

  console.log(formattedImages);

  setImages(formattedImages);
})
      .catch((err) => console.error("Error fetching images:", err));
  }, []);

  const totalImages = images.length;

  // Duplicate for infinite scroll
  const sliderImages = [...images, ...images];

  // Auto slide
  useEffect(() => {
    const interval = setInterval(() => {
      setOffset((prev) => prev + 1);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Reset loop
  useEffect(() => {
    if (offset === totalImages && totalImages !== 0) {
      containerRef.current.style.transition = "none";
      setOffset(0);
      containerRef.current.getBoundingClientRect();
      containerRef.current.style.transition = "transform 1s ease-in-out";
    }
  }, [offset, totalImages]);

  return (
    <div className="images-wrapper">
      <div
        className="image-container"
        ref={containerRef}
        style={{
          transform: `translateX(-${offset * (100 / visibleCount)}%)`,
          width: `${(sliderImages.length / visibleCount) * 100}%`,
          transition: "transform 1s ease-in-out",
        }}
      >
        {sliderImages.map((img, index) => (
          <div key={index} className="image-box">
            <img src={img} alt={`annual-${index}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnualDayImageSwapper;